import {leadApiPost} from "./api";
import {parseUrl} from "../helperFunctions";

const parsedUrl = parseUrl();

const getUserRegisterOrUpdateData = (store) => {

  const {userInfo, userLocation} = store.userState;
  const {email, firstName, lastName, phone, city, state, country, postal, address2} = userInfo; // address is not used
  const {streetNumber, streetName} = userLocation;

  return {
    email,
    firstName,
    lastName,
    phone,
    address1: (streetNumber ? streetNumber + " " : "") + streetName,
    address2,
    city,
    state,
    country,
    phone2: "",
    agreedToTerms: true,
    subscribeToNewsletter: true,
    isNew: true,
    postal,
    salesPersonEmail: (window.salesPerson ? window.salesPerson.email : ""),
    salesPersonFullName: (window.salesPerson ? window.salesPerson.name : ""),
    employeeId: window.salesPerson
      ? window.salesPerson.rawVal / ( Math.floor(Math.PI * 1000))
      : (parsedUrl && parsedUrl.p) ? +parsedUrl.p.split("/")[0] : "",
    fabricatorId: document.kvConfig.userId || 61986,
    quoteRequestType: "ScheduleAnAppointment", // QuoteRequestType
    yesNoConsultationRequest: false,
    preferredCommunicationMethod: "",
    howDidYouHearAboutUs: "",
    language: "en-US",
    subId: document.subId && document.subId.toString ? document.subId.toString() : null,
  };
}

export const registerUser = (store) => {
  return leadApiPost("/api/Public/RegisterClient", getUserRegisterOrUpdateData(store))
}

export const updateUser = (store) => {
  const {registeredUserAuthToken} = store.userState;
  const headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + registeredUserAuthToken,
  }
  return leadApiPost("/api/client/update-with-token", getUserRegisterOrUpdateData(store), headers)
}
